import { render } from "./ConfigurationForm.vue?vue&type=template&id=4900e70a&scoped=true"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js"

import "./ConfigurationForm.vue?vue&type=style&index=0&id=4900e70a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900e70a"]])

export default __exports__